export default __webpack_public_path__ + "97ff43ffa4f3faa6a8818e352a8b9c7b.svg";